import React from 'react'
import PropTypes from 'prop-types'
import { EditBeneficiaryForm } from 'local/components'

const BeneficiaryAddComponent = ({ onSubmit }) => (
  <EditBeneficiaryForm header="Add Beneficiary" onSubmit={onSubmit} />
)

BeneficiaryAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default BeneficiaryAddComponent
